module.exports = __webpack_public_path__ + "img/goods1_7.6dabbd06.jpg";